import { t } from 'i18next';
import { RoundBadge, ThumbnailPhotoCard } from '@peacecover/component';

interface CellListPocaProps {
  imgUrl: string;
  title: string;
  subTitle: string;
  price: string;
  isDone: boolean;
  className?: string;
  imgClassName?: string;
}

const CellListPoca = ({
  imgUrl,
  title,
  subTitle,
  price,
  isDone,
  className = '',
  imgClassName = ''
}: CellListPocaProps) => {
  return (
    <div
      className={`flex justify-between rounded-[12px] border border-separator1 dark:bg-separator2 ${className}`}
    >
      <div className="flex items-center gap-[8px]">
        <ThumbnailPhotoCard
          imageUrl={imgUrl}
          className={`w-[29px] h-[46px] rounded-[4px] ${imgClassName}`}
        />
        <div className="flex flex-col items-start gap-[5px] leading-none">
          <p className="text-[12px] font-bold text-on-label">{title}</p>
          <p className="text-[11px] text-text-sub-lv1">{subTitle}</p>
        </div>
      </div>
      <div className="flex flex-col justify-center items-end gap-[3px]">
        <RoundBadge size="small" className="h-[15px] px-[5px] py-[2px] text-[9px] rounded-[20px]">
          {isDone
            ? t('TradingPhotoCardReviewsPage.status.done')
            : t('TradingPhotoCardReviewsPage.status.isExchange')}
        </RoundBadge>
        <p className="text-[15px] font-semibold text-text-primary leading-none">
          {price ?? t('TradingPhotoCardReviewsPage.offer')}
        </p>
      </div>
    </div>
  );
};

export default CellListPoca;
